import { useUser } from "@shared/utils/hooks/misc";
import { RocketIcon } from "common/Icons/Icons";
import styled, { useTheme } from "styled-components";
import Text from "common/Typography/Text";
import { CSSProperties } from "react";
import { getPurchaseSubscriptionPath } from "features/settings/common/utils";
import { useRestrictedCountriesPurchase } from "utils/hooks/misc";

interface GetFullAccessButtonProps {
  style?: CSSProperties;
}

const UpgradeButton = ({ style }: GetFullAccessButtonProps) => {
  const theme = useTheme();
  const { user } = useUser();
  const { onPurchaseClick } = useRestrictedCountriesPurchase();
  const isDarkMode = theme.isDarkMode;

  if (user?.isPro()) return null;

  return (
    <StyledButton
      $isDarkMode={isDarkMode}
      style={style}
      onClick={() =>
        onPurchaseClick(getPurchaseSubscriptionPath({ isAllPlans: true }))
      }
    >
      <StyledRocketIcon />
      <ButtonText>Upgrade</ButtonText>
    </StyledButton>
  );
};

export default UpgradeButton;

const StyledButton = styled.div<{ $isDarkMode?: boolean }>`
  background: ${(p) =>
    p.$isDarkMode
      ? "linear-gradient(92.77deg, #6ADAFB -2.78%, #70A8FF 104.85%)"
      : "linear-gradient(117.02deg, #6abbfa 4.73%, #0f54e9 98.99%)"};
  white-space: nowrap;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 6px 16px;
  cursor: pointer;
  width: fit-content;
  &:hover {
    opacity: 0.85;
  }
`;
const ButtonText = styled(Text)`
  color: ${(p) => p.theme.colors.buttonText};
  margin-left: 8px;
`;
const StyledRocketIcon = styled(RocketIcon)`
  width: 16px;
  height: 16px;
  fill: ${(p) => p.theme.colors.buttonText};
`;
